import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import config from 'config/default.json';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import { FormControl } from '@angular/forms';
import { TableComponent } from '../table/table.component';
import Chart, { ChartConfiguration } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(ChartDataLabels);
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss', '../../components/table/table.component.scss']
})
export class DashboardComponent extends TableComponent{
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer) {
      super(sanitizer);
    }
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() data:{[x: string]: any} = {} ;
  @Input() platformInfos: { [x:string]: any } = new Map();

  userControl = new FormControl();
  userInputControl = new FormControl();
  allUsers:any = [];
  dailyProcessContent:{[x: string]: any} = {}
  
  chartEvolution: Chart | null = null;
  chartDailyProcess: Chart | null = null;
  chartGlobalProjectContent: Chart | null = null;
  chartProjectContent: Chart | null = null;
  chartGlobalRawContent: Chart | null = null;
  chartRawContent: Chart | null = null;
  chartContent: Chart | null = null;

  userStatClassified: any[] = [];
  userStatEdited:any[] = [];
  chartClassified: Chart | null = null;
  chartEdited: Chart | null = null;
  
  ngOnInit(): void {
    this.userInputControl.valueChanges.pipe(
      filter(query => query && query.length > 2),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((query) => {
        this.sharedService.sendData({in_progress: true});
        return this.apiService.queryData(config.master.ndapi.url+'/enovsky/web/administration/search_user', {search_key: query}, this.userInfos['access_token'])
      })
    ).subscribe((options) => {
      this.allUsers = options;
      this.sharedService.sendData({in_progress: false});
    });
    if( this.data['data'] && Object.keys(this.data['data']).length > 0){
      this.dailyProcessContent = this.data['daily_content_process'];
      this.createDailyProcessVisualization();
      this.createVisualization();
      this.createEnovskyGuess();
      this.setUserStatistics();
    } 
  }
  setUserStatistics(){
    this.userStatClassified = this.data['stat_classifiers'];
    this.userStatEdited = this.data['stat_editors'];
    this.drawStatistics();
  }
  drawStatistics(){
    const labelsClassified = this.userStatClassified.map(u => u.user_name);
    const valuesClassified = this.userStatClassified.map(u => u.nb_element);

    const labelsEdited = this.userStatEdited.map(u => u.user_name);
    const valuesEdited = this.userStatEdited.map(u => u.nb_element);
    const extraValuesEdited = this.userStatEdited.map(u => u.nb_second_element);
    

    if(this.chartClassified) (this.chartClassified as Chart).destroy()
    if(this.chartEdited) (this.chartEdited as Chart).destroy()
      
    this.chartClassified = new Chart(this.elRef.nativeElement.querySelector('.spliting-podium'), this.barChartParams(labelsClassified, valuesClassified, [], 'Contents'));
    this.chartEdited = new Chart(this.elRef.nativeElement.querySelector('.editing-podium'), this.barChartParams(labelsEdited, valuesEdited, extraValuesEdited, 'Contents'));
    
  }
  createEnovskyGuess(){
    this.dataSource = this.data['vistit_stat'];
    this.showedRows = this.dataSource;
  }
  loadDailyProcess(){
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/dashboard/daily_process', {id_user: this.userControl.value, platform_infos: this.platformInfos}, this.userInfos['access_token']).subscribe((response)=>{
      this.dailyProcessContent = response;
      
      if(this.chartDailyProcess) (this.chartDailyProcess as Chart).destroy()
      this.createDailyProcessVisualization();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange && Object.keys(changes['data']).length > 0) this.buildData();
  }
  buildData(){
    if(this.chartEvolution) (this.chartEvolution as Chart).destroy()
    if(this.chartGlobalProjectContent) (this.chartGlobalProjectContent as Chart).destroy()
    if(this.chartDailyProcess) (this.chartDailyProcess as Chart).destroy()
    if(this.chartProjectContent) (this.chartProjectContent as Chart).destroy()
    if(this.chartGlobalRawContent) (this.chartGlobalRawContent as Chart).destroy()
    if(this.chartRawContent) (this.chartRawContent as Chart).destroy()
    if(this.chartContent) (this.chartContent as Chart).destroy()

    this.dailyProcessContent = this.data['daily_content_process'];
    this.createDailyProcessVisualization();
    this.createVisualization();
    this.createEnovskyGuess();
    this.setUserStatistics();
  }
  async createDailyProcessVisualization(){
    //console.log(this.dailyProcessContent)
    this.chartDailyProcess = new Chart(this.elRef.nativeElement.querySelector('.user-daily-process'), {
      type: 'line',
      data: {
          labels: this.dailyProcessContent['abscissa'],
          datasets: [{
            label: 'Splitted',
            fill: false,
            backgroundColor: '#ec9f53',
            borderColor: '#ec9f53',
            data: this.dailyProcessContent['nb_splitted']
          },{
              label: 'Classified',
              fill: false,
              backgroundColor: '#4BC0C0',
              borderColor: '#4BC0C0',
              data: this.dailyProcessContent['nb_classified']
          },{
            label: 'Edited',
            fill: false,
            backgroundColor: '#016F86',
            borderColor: '#016F86',
            data: this.dailyProcessContent['nb_edited']
        }
  ]
      },
      options: {
          responsive: true, 
          maintainAspectRatio: false,
          scales: { 
            x: {title: { display: true, text: 'Months'} },
            y: {title: { display: true, text: 'Number of Content processed', }, beginAtZero: true, }
          },
          animation: { duration: 1,
            onComplete: function () {
              }
          }
      }
    });
  }
  async createVisualization() {
      /* EVOLUTION  */
    this.chartEvolution = new Chart(this.elRef.nativeElement.querySelector('.student-evolution'), {
      type: 'line',
      data: {
          labels: this.data['evolution'].abscissa,
          datasets: [{
              label: 'Total Monthly registered',
              fill: false,
              backgroundColor: '#36A2EB',
              borderColor: '#36A2EB',
              data: this.data['evolution'].total_student
          },{
            label: 'Monthly registered',
            fill: false,
            backgroundColor: '#4BC0C0',
            borderColor: '#4BC0C0',
            data: this.data['evolution'].nb_student
        }
  ]
      },
      options: {
        responsive: true, 
        maintainAspectRatio: false,
        scales: { 
          x: {title: { display: true, text: 'Months'} },
          y: {title: { display: true, text: 'Number of register', }, beginAtZero: true, }
        },
        animation: { duration: 1,
          onComplete: function () {
            }
        }
      }
    });
    
  //Global Project Content
  this.chartGlobalProjectContent = new Chart(this.elRef.nativeElement.querySelector('.global-project-content'),{
    type: 'pie',
    data: {
      labels: ['Proccessing', 'Proccessed'],
      datasets: [
        {
          label: 'Value',
          data: [this.data['raw_project'].proccessing_content, this.data['raw_project'].proccessed_content],
          backgroundColor: ['#ec9f53', '#016F86'],
        }
      ]
    },
    options: {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: 'Proccessed Contents'
        }
      }
    },
  }
  );

  //Project Content
    this.chartProjectContent = new Chart(this.elRef.nativeElement.querySelector('.project-content'),{
      type: 'bar',
      data:  {
        labels: this.data['project_content'].abscissa,
        datasets: [{
          label: 'Number Content',
          backgroundColor: '#36A2EB',
          borderColor: '#36A2EB',
          data: this.data['project_content'].nb_content,
            borderWidth: 1
        },
        {
          label: 'Splitted',
          backgroundColor: '#ec9f53',
          borderColor: '#ec9f53',
          data: this.data['project_content'].nb_splitted,
            borderWidth: 1
        },
        {
          label: 'Classified',
          backgroundColor: '#4BC0C0',
          borderColor: '#4BC0C0',
          data: this.data['project_content'].nb_classified,
            borderWidth: 1
        },
        {
          label: 'Edited',
          backgroundColor: '#016F86',
          borderColor: '#016F86',
          data: this.data['project_content'].nb_edited,
            borderWidth: 1
        },
        {
          label: 'Imported',
          backgroundColor: '#2E8B57',
          borderColor: '#2E8B57',
          data: this.data['project_content'].nb_imported,
            borderWidth: 1
        }]
      },
      options: {
        layout: {padding: {right: 18}},
        scales: {
            x: {
                min: 0,
                ticks: {
                  //minRotation: 70
                }
              },
              y: {
                min: 0,
                beginAtZero: true
              },
        },
        
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 2,
          onComplete: function () {
              let ctx = this.ctx;
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';
              this.data.datasets.forEach(function (dataset, i) {
              });  
          }
        }
    }

  });
  //Global Raw Content
  this.chartGlobalRawContent = new Chart(this.elRef.nativeElement.querySelector('.global-raw-content'),{
    type: 'pie',
    data: {
      labels: ['In Project', 'Out of Project'],
      datasets: [
        {
          label: 'Value',
          data: [this.data['raw_project'].with_project, this.data['raw_project'].without_project],
          backgroundColor: ['#016F86', '#ec9f53'],
        }
      ]
    },
    options: {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: 'Project Contents'
        }
      }
    },
  }
  );

  //Raw Content
    this.chartRawContent = new Chart(this.elRef.nativeElement.querySelector('.raw-content'),{
      type: 'bar',
      data:  {
        labels: this.data['raw_content'].abscissa,
        datasets: [{
          label: 'In Project',
          backgroundColor: '#016F86',
          borderColor: '#016F86',
          data: this.data['raw_content'].with_project,
            borderWidth: 1
        },
        {
          label: 'Out of Project',
          backgroundColor: '#ec9f53',
          borderColor: '#ec9f53',
          data: this.data['raw_content'].without_project,
            borderWidth: 1
        }]
      },
      options: {
        layout: {padding: {right: 18}},
        scales: {
            x: {
                min: 0,
                ticks: {
                  //minRotation: 70
                }
              },
              y: {
                min: 0,
                beginAtZero: true
              },
        },
        
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 2,
          onComplete: function () {
              let ctx = this.ctx;
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';
              this.data.datasets.forEach(function (dataset, i) {
              });  
          }
        }
    }

  });
  //Available Content
  this.chartContent = new Chart(this.elRef.nativeElement.querySelector('.available-content'),{
    type: 'bar',
    data:  {
      labels: this.data['content'].abscissa,
      datasets: [{
        label: 'Nombre de contenus',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        data: this.data['content'].ordinate,
          borderWidth: 1
      }]
    },
    options: {
      layout: {padding: {right: 18}},
      scales: {
          x: {
              min: 0,
              ticks: {
                //minRotation: 70
              }
            },
            y: {
              min: 0,
              beginAtZero: true
            },
      },
      
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 100,
        easing: 'easeOutBounce',
        onComplete: function () {
            let ctx = this.ctx;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';
            this.data.datasets.forEach(function (dataset, i) {
            });  
        }
      }
  }

  });




  
  }
  barChartParams(labelsEdited: string[], valuesEdited: number[], extraValues: number[], keyWord:string): ChartConfiguration<'bar', number[], string> {
    const medals = ['🥇 ', '🥈 ', '🥉 '];
    const medalColors = ['#FFD700', '#C0C0C0', '#CD7F32'];
    const defaultColor = '#4e73df';
    const formattedLabels = labelsEdited.map((label, index) =>
      index < 3 ? medals[index] + label : label
    );

    const backgroundColors = valuesEdited.map((_, index) =>
      index < 3 ? medalColors[index] : defaultColor
    );
    return {
      type: 'bar',
      data: {
        labels: formattedLabels,
        datasets: [
          {
            data: valuesEdited,
            backgroundColor: backgroundColors,
            borderRadius: 5
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx:any) => `${ctx.raw} ${keyWord}`
            }
          },
          datalabels: {
            anchor: 'end',
            align: 'top',
            font: {
              weight: 'bold'
            },
            formatter: (value: number, context: any) => {
              const index = context.dataIndex;
              return extraValues[index]; // show second value
            }
          }
        },
        scales: {
          x: {
            grid: { display: false }
          },
          y: {
            beginAtZero: true,
            grace: '10%',
            ticks: { precision: 0 },
              title: {
              display: true,
              text: keyWord,
              font: {
                size: 14,
                weight: 'bold'
              }
            }
          }
        }
      }
    };
  }
  applyFilterLocal(element:any, column:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applyFilter(element.value, column);
    this.cdRef.detectChanges();
  }
  applySortLocal(element:any, column:string, type:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applySort(element, column, type);
    this.cdRef.detectChanges();
  }
}
